import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const UserCreationPage = withSuspense(
	lazy(async () => await import('./user-creation-page.component')),
	PageLoader,
);
